import { FC } from 'react';
import { CustomModal, CustomTable } from '@mybonum/ui';
import { useQuery } from '@tanstack/react-query';
import { Divider } from 'antd';

import { useColumns } from './hooks/use-columns.tsx';
import { normalizeData } from './utils/normalize-data.ts';
import { TAdminAppointmentType, TAppointmentsPopupProps } from './types.ts';

import { API } from '@/services/api';

export const AppointmentsPopup: FC<TAppointmentsPopupProps> = ({ customer, open, onClose }) => {
    const { data, isLoading, isPending } = useQuery({
        ...API.APPOINTMENTS.getAppointments({
            user_id: customer?.id as number,
        }),
        enabled: open && customer !== null,
    });

    const columns = useColumns();

    const title = customer ? `Appointments — ${customer.fullName}` : 'Appointments';

    return (
        <CustomModal
            width={1440}
            open={open}
            padding="small"
            onCancel={onClose}
            title={title}
            footer={null}
        >
            <Divider style={{ marginTop: 0 }} />
            <CustomTable<TAdminAppointmentType>
                scroll={{ x: true }}
                loading={isPending || isLoading}
                columns={columns}
                dataSource={normalizeData(data?.result || [])}
                rowKey="id"
                pagination={false}
            />
        </CustomModal>
    );
};
